module.exports = __webpack_public_path__ + "img/d0bdce467037a7605a875e562a39c4bf.png";